import { PropsWithChildren } from "react";
import { Button } from "./styles";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

export type LoadMoreProps = {
  loadMore: () => void;
  isLoadingMore?: boolean;
};

const LoadMore: React.FC<LoadMoreProps> = (props) => {
  const { loadMore, isLoadingMore } = props;
  const { locale = "it" } = useRouter();
  const t = {
    loadMore: useTranslation("newsPage.loadMore", locale),
  };

  return (
    <Button disabled={isLoadingMore} onClick={() => loadMore()}>
      {t.loadMore}
    </Button>
  );
};

export default LoadMore;
